import React from 'react';
import PropTypes from 'prop-types';
import './icon.scss';

const GeckoIcon = ({ icon }) => {
  const className = `gecko-icon${icon ? ` ${icon}` : ''}`;
  return <i className={className} aria-hidden={true} />;
};

GeckoIcon.propTypes = {
  icon: PropTypes.string.isRequired,
};

export default GeckoIcon;
